export const HTTP_METHODS = Object.freeze({
  GET: "get",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete",
});

export const HTTP_STATUS = Object.freeze({
  400: "Bad Request",
  401: "Unauthorized",
  403: "Forbidden",
  404: "Not Found",
  500: "rs_statuscode_500_message",
});

export const BUTTON_TYPES = Object.freeze({
  Save: "save",
  Cancel: "cancel",
  Delete: "delete",
  Edit: "edit",
  Add: "add",
  Back: "back",
  Next: "next",
  Finish: "finish",
  Close: "close",
  Search: "search",
  Reset: "reset",
  Send: "send",
  Confirm: "confirm",
  Reject: "reject",
  Accept: "accept",
  Preview: "preview",
  Download: "download",
  Upload: "upload",
  Calculator: "calculator",
  Secondary: "secondary",
  Note: "note",
  Config: "config",
  Refresh: "refresh",
  Export: "export",
  Details: "details",
  Generate: "generate",
  GenerateReport: "generate-report",
  SendEmail: "send-email",
  Pending: "pending",
  Posted: "posted",
  FileCheck: "file-check",
  Update: "update",
  ExcelFileCheck: "excel-file-check",
  Archive: "archive",
  GenerateExcelFile: "generate-excel-file",
  Activate: "activate",
  Deactivate: "deactivate",
  Copy: "copy",
  Undo: "undo",
  Link: "link",
  Check: "check",
  Uncheck: "uncheck",
  Transfer: "transfer",
  Import: "import",
  Play: "play",
  Stop: "stop",
  Clear: "clear",
  Danger: "danger",
  Sync: "sync",
  Password: "password",
  List: "list",
  QrCode: "qr-code",
  Share: "share",
  OK: "ok",
  Clone: "clone",
  Logout: "logout",
});

export const PERMISSIONS = Object.freeze({
  PartnerPortal: "PartnerPortal",
});
